import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';

import { connectRouterWithHistory } from 'modules/core/modules/router';
import { reducer as translateReducer } from 'modules/core/modules/translations';

export default function createRootReducer(reducers = {}) {
    const rootReducer = combineReducers({
        ...reducers,
        translate: translateReducer,
        form: formReducer,
        router: connectRouterWithHistory,
        firebase: firebaseReducer,
        firestore: firestoreReducer,
    });

    return rootReducer;
}
